<template>
    <div>
        <buttonlist
                @help="help"
                @search="search"
                @reflash="reflash"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
        <el-button type="primary" size="mini" @click="updateDictionary">{{$t('getapi[7971]')}}</el-button>
        </div>
        <!--<el-input v-model="positionKey" class="input-with-select" style="width:250px;margin-left: 8px">
            <el-button size="mini" slot="append" icon="el-icon-search" @click="confirmSearchPosition()"></el-button>
        </el-input>-->
        <div id="xpane-0">
        <vxe-table
                ref="singleTable"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                resizable
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
        >
            <vxe-table-column show-overflow-tooltip field="ID" title="ID" width="100">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="Chinese" :title="$t('getapi[946]')" width="200">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="English" :title="$t('getapi[947]')" width="200">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="Hungary" :title="$t('getapi[948]')" width="200">
            </vxe-table-column>
            <vxe-table-column show-overflow-tooltip :title="$t('getapi[6048]')" width="60">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small">
                        {{$t('getapi[34]')}}
                    </el-button>
                </template>
            </vxe-table-column>
        </vxe-table>
        </div>

        <serce :isVisible="isVisible" queryData="Translation" ref="ser" @getser="serclick"></serce>

        <el-dialog v-dialogDrag :title="$t('getapi[8078]')" :visible.sync="isShowEdit" width="30%" :close-on-click-modal="false">
            <!--<el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="120px"
                             label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="ID">
                                    <el-input v-model="dataDetail.ID" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[946]')">
                                    <el-input v-model="dataDetail.Chinese"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[947]')">
                                    <el-input v-model="dataDetail.English"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[948]')">
                                    <el-input v-model="dataDetail.Hungary"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>

            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>ID</td>
                        <td> <el-input v-model="dataDetail.ID" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[946]')}}</td>
                        <td>   <el-input v-model="dataDetail.Chinese"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[947]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.English"></el-input>
                        </td>
                        <td>{{$t('getapi[948]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.Hungary"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="samll" @click="isShowEdit = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="samll" type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'translation',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                queryData: [], // 查询数组
                pageIndex: 1, // 当前页
                pageSize: 100000, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    ID:'',
                    Chinese: '',
                    English: '',
                    Hungary: ''
                },
                positionKey: '', //查询
                isShowEdit: false,
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            /*that.getView(),*/
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8078]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'Translation');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                console.log(data)
                that.$http.urlpost('/Sys/Currency/GetLanguageInfo', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
                that.authority();
            },
            // 编辑
            edit(row) {
                let that = this
                that.isShowEdit = true
                that.dataDetail.ID = row.ID
                that.dataDetail.Chinese = row.Chinese
                that.dataDetail.English = row.English
                that.dataDetail.Hungary = row.Hungary
            },
            //更新数据字典
            updateDictionary(){
                let that = this
                that.$http.urlpost('/Sys/Currency/updateDictionary', '', function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            //保存
            save(){
                let that = this
                if(that.dataDetail.Chinese){
                    that.dataDetail.Chinese = that.dataDetail.Chinese.replace(/(\r\n)|(\n)/g,'').replace(/['"\\'\\"]/g, '')
                }
                if(that.dataDetail.English ){
                    that.dataDetail.English = that.dataDetail.English.replace(/(\r\n)|(\n)/g,'').replace(/['"\\'\\"]/g, '')
                }
                let parm = that.dataDetail
                that.$http.urlpost('/Sys/Currency/SaveLanguage', parm, function(res) {
                    if(res.Success == 1){
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            // 查询
            confirmSearchPosition(){
                let that = this
                if(that.positionKey == ''){
                    return
                }
                let row = null
                for(let i =0;i<that.dataSet.length;i++){
                    if(that.positionKey.toUpperCase() == that.dataSet[i].Chinese.toUpperCase()){
                        row = that.dataSet[i]
                    }
                }
                if(row != null){
                    that.$refs.singleTable.setCurrentRow(row);
                    setTimeout(() => {
                        this.$refs.singleTable.scrollToRow(row)
                    }, 200);
                    /*setTimeout(() => {
                        let node = document.querySelector('.el-table__body tr.current-row');
                        if (node) {
                            setTimeout(() => {
                                let top = $(node).position().top;
                                this.$refs.singleTable.bodyWrapper.scrollTop = top;
                            }, 200);
                        }
                    }, 0);*/
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
